import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import qs from 'qs';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import { submit } from 'redux-form';
import { withStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import ConfirmPasswordForm from '../../components/forms/ConfirmPasswordForm.jsx';
import SpinnerOverlay from '../../components/Spinner/SpinnerOverlay.jsx';
import * as UserActions from '../../redux/actions/user.actions';
import * as UtilsActions from '../../redux/actions/utils.actions';
import * as ModalActions from '../../redux/actions/modal.actions';
import { isMobileBrowser } from '../../_config/utils';

const styles = theme => ({
  root: {
    flexGrow: 1,
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    padding: '20px 20px',
    backgroundColor: '#157495',
    backgroundImage: 'url(/imgs/common/loginBackground.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(to right, rgba(21, 116, 149, 0.7), rgba(21, 116, 149, 0.7))',
      zIndex: 0,
    },
  },
  centerPanel: {
    width: '100%',
    maxWidth: '600px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    zIndex: 1,
  },
  logo: {
    height: '80px',
    marginBottom: '20px',
  },
  formCard: {
    width: '100%',
    padding: '40px',
    backgroundColor: 'white',
    borderRadius: '12px',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
  },
  formHeader: {
    marginBottom: '32px',
    textAlign: 'center',
  },
  formTitle: {
    fontSize: '32px',
    fontWeight: '600',
    color: '#333',
    marginBottom: '12px',
    marginTop: 0,
  },
  formSubtitle: {
    color: '#666',
    fontSize: '15px',
    lineHeight: '1.6',
    marginBottom: 0,
  },
  mobileContainer: {
    minHeight: '100vh',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    backgroundColor: '#157495',
    backgroundImage: 'url(/imgs/common/loginBackground.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed',
    padding: '40px 20px',
    position: 'relative',
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::before': {
      content: '""',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(135deg, rgba(21, 116, 149, 0.92), rgba(18, 99, 127, 0.95))',
      zIndex: 0,
    }
  },
  mobileContent: {
    position: 'relative',
    zIndex: 2,
    width: '100%',
    maxWidth: '400px',
    marginTop: 'auto',
    marginBottom: 'auto',
  },
  mobileLogo: {
    height: '70px',
    marginBottom: '30px',
    display: 'block',
    margin: '0 auto 30px',
  },
  mobileTitle: {
    fontSize: '28px',
    fontWeight: '600',
    color: 'white',
    textAlign: 'center',
    marginBottom: '12px',
    marginTop: 0,
    textShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
  },
  mobileSubtitle: {
    color: 'rgba(255, 255, 255, 0.9)',
    fontSize: '15px',
    textAlign: 'center',
    marginBottom: '32px',
    lineHeight: '1.6',
  },
  securityBadge: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '24px',
    padding: '12px',
    backgroundColor: 'rgba(76, 182, 172, 0.1)',
    borderRadius: '8px',
    fontSize: '13px',
    color: '#4DB6AC',
    fontWeight: '500',
    '& svg': {
      marginRight: '8px',
      fontSize: '18px',
    }
  }
});

@connect((state) => ({ userCredentials: state.user.userLogin, routing: state.router }))
class ResetPassword extends React.Component {
  
  async confirmPassword(values) {
    const { dispatch, routing } = this.props;
    dispatch(UtilsActions.setSpinnerVisibile(true));
    try {
      const parsed = qs.parse(routing.location.search, { ignoreQueryPrefix: true });
      const token = parsed.token;
      const userId = parsed.userId;
      await dispatch(UserActions.confirmPassword(userId, token, values));
      dispatch(replace('/resetPassLanding'));
    } catch (error) {
      let errorMessage = 'errorSetPassword';
      if (error && error.response && error.response.data && error.response.data.code && error.response.data.code === 10105) errorMessage = 'setPasswordTokenExpired';
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_MODAL',
        modalProps: { type: 'DEFAULT_ERROR', defaultMessage: <Entity entity={errorMessage} /> },
      }));
    } finally {
      dispatch(UtilsActions.setSpinnerVisibile(false));
    }
  }

  render() {
    const { dispatch, classes } = this.props;
    const isMobile = isMobileBrowser();

    if (isMobile) {
      return (
        <div style={{
          minHeight: '100vh',
          width: '100%',
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          overflowY: 'auto',
          overflowX: 'hidden',
          WebkitOverflowScrolling: 'touch',
          backgroundColor: '#157495',
        }}>
          <div style={{
            height: '120vh',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            backgroundImage: 'url(/imgs/common/loginBackground.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundAttachment: 'fixed',
            padding: '30px 20px',
            position: 'relative',
          }}>
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              minHeight: '100%',
              background: 'linear-gradient(135deg, rgba(21, 116, 149, 0.92), rgba(18, 99, 127, 0.95))',
              zIndex: 0,
              pointerEvents: 'none',
            }} />
            <div style={{
              position: 'relative',
              zIndex: 2,
              width: '100%',
              maxWidth: '400px',
              paddingTop: '0px',
              paddingBottom: '40px',
            }}>
              <img 
                src="/imgs/common/logoJagoWhite.png" 
                alt="Luckey" 
                style={{
                  height: '50px',
                  marginBottom: '10px',
                  display: 'block',
                  margin: '0 auto 10px',
                }}
              />
              <h1 style={{
                fontSize: '20px',
                fontWeight: '600',
                color: 'white',
                textAlign: 'center',
                marginBottom: '8px',
                marginTop: 0,
                textShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
              }}>
                <Entity entity="setYourPassword" />
              </h1>
              <p style={{
                color: 'rgba(255, 255, 255, 0.9)',
                fontSize: '12px',
                textAlign: 'center',
                marginBottom: '20px',
                lineHeight: '1.5',
              }}>
                <Entity entity="createSecurePasswordMessage" />
              </p>
              <ConfirmPasswordForm
                onValidateForm={() => dispatch(submit('ConfirmPasswordForm'))}
                onSubmit={(values) => this.confirmPassword(values)}
              />
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className={classes.root}>
        <div className={classes.centerPanel}>
          <img 
            src="/imgs/common/logoJagoWhite.png" 
            alt="Luckey"
            className={classes.logo}
          />
          
          <div className={classes.formCard}>
            <div className={classes.formHeader}>
              <h2 className={classes.formTitle}>
                <Entity entity="setYourPassword" />
              </h2>
              <p className={classes.formSubtitle}>
                <Entity entity="createSecurePasswordMessage" />
              </p>
            </div>
            
            <ConfirmPasswordForm
              onValidateForm={() => dispatch(submit('ConfirmPasswordForm'))}
              onSubmit={(values) => this.confirmPassword(values)}
            />
          </div>
        </div>
      </div>
    );
  }
} 

export default withStyles(styles)(ResetPassword);
